import { useEffect, useState } from 'react';

import Authorization from '../../stores/Authorization';
import { DatabaseAppSettingsEnum } from '../../utilities/Constants';
import { IQueryColumnDefinitionModel } from '../../interfaces/IQuery';
import { Loader } from '../../components/shared/Loader';
import { LocalRoutes } from '../../utilities/LocalRoutes';
import { ViewExportReport } from '../../components/report/ViewExportReport';
import { useAuthContext } from '../../contexts/AuthContext';
import { useGetDbAppSettings } from '../../shared/react-query-hooks/useGetDbAppSettings';
import { useParams } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';
import { userGetReportTypeDetail } from '../../components/report/userGetReportTypeDetail';

function ViewExportReportWrapper() {
    const { id: typeId } = useParams();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    const [defaultAuditFields, setDefaultAuditFields] = useState<IQueryColumnDefinitionModel[]>([]);

    const reportDetailsApi = userGetReportTypeDetail(parseInt(typeId || ''));
    const appSettingsApi = useGetDbAppSettings();

    useEffect(() => {
        if (appSettingsApi.isFetched) {
            const defaultAuditFieldsSetting = appSettingsApi.data?.find(
                (x) => x.name === DatabaseAppSettingsEnum.CaseAuditLogFields
            );

            if(!defaultAuditFieldsSetting) {
                setDefaultAuditFields([]);
                return;
            }

            const values: IQueryColumnDefinitionModel[] = JSON.parse(
                defaultAuditFieldsSetting?.value ?? ''
            );

            const sortedValues = values.sort((a, b) => ((a.name ?? '') < (b.name ?? '') ? -1 : 1));
            setDefaultAuditFields(sortedValues);
        }
    }, [appSettingsApi.isFetched]);

    useEffect(() => {
        const isAuthorized = Authorization.isAuthorizedToRoute(
            LocalRoutes.ReportDetail,
            user,
            zoneContext.zoneGuid
        );

        if (!isAuthorized) {
            window.location.assign(LocalRoutes.AccessDenied);
            return;
        }

        const hasReportId = typeId !== undefined;
        if (!hasReportId) {
            window.location.assign('/');
        }
    }, []);

    if (!reportDetailsApi.isFetched || !appSettingsApi.isFetched) {
        return <Loader />;
    }

    return (
        <ViewExportReport
            defaultAuditFieldSettings={defaultAuditFields}
            data={reportDetailsApi.data!}
            isLoading={reportDetailsApi.isFetching}
            typeId={parseInt(typeId || '')}
            user={user}
            zoneContext={zoneContext}
        />
    );
}

export default ViewExportReportWrapper;
